import { toggleTagTypesLookup } from "../AnnoLightbox/configs/toggleTagTypesLookup";

/**
 * @description this function is called inside the
 * Mark node mutation listener in AnnoPlugin.
 *
 * Its job is to:
 * For every mutated Mark Node, identify if it is either
 * - an overlapping one : in which case expose its overlap count to CSS so the
 *   stylesheet can render the additive-opacity highlight
 * - a toggle tag type anno : in which case apply the appropriate 'color className' to its DOM element
 */
export const applyClassesForAnnoColor = ({
    element,
    latestAnnoDataRef,
    ids,
    node
}) => {

  const prevClassesAry = element?.classList.toString().split(" ") || [];

  if (element !== null) {
    /**
     * ids represents the dataIds behind this annotation.
     * so lets get the actual data behind. And if in even one of those datas,
     * tags.vocabs.data[0] exists then: -is-vocabs-
     * tags.quotes.data[0] exists then: -is-quotes-
     */
    const annoDataAgainstTheseIds = latestAnnoDataRef?.current
      ? ids.map((dataId) => latestAnnoDataRef.current[dataId])
      : [];

    toggleTagTypesLookup.forEach(({ tagType, className }) => {
      if (
        annoDataAgainstTheseIds.some((aD) => {
          return aD?.tags && aD?.tags[tagType]?.data?.length > 0;
        })
      ) {
        //if this class doesnt already exist then add it.
        if (!prevClassesAry.find((cN) => cN === className)) {
          element.classList.add(className);
        }
      } else {
        //if this class already exists then remove it.
        if (prevClassesAry.find((cN) => cN === className)) {
          element.classList.remove(className);
        }
      }
    });

    /**
     * Overlap rendering.
     *
     * We do NOT compute an alpha value here. Instead we expose the number of
     * annotations stacked on this fragment (`ids.length`) to CSS via the
     * `--anno-depth` custom property. The stylesheet (themes/anno.js) turns
     * that count into the highlight opacity, so that overlapping annotations
     * get progressively darker — the way overlapping translucent rectangles
     * composite additively. Keeping the math in CSS means a single fragment
     * with N annotations and N nominal layers both read the same way, and the
     * `disableAnnoColors` / hover / selected / quotes / vocabs rules (all
     * background-color based) keep overriding it cleanly.
     */
    element.style.setProperty("--anno-depth", String(ids.length));
  }
};
